export function draw(el: string) {
  var canvas = document.querySelector(el) as any // 获取到canvas的对象，演员
  var canvasWidth = canvas.clientWidth
  var canvasHeight = canvas.clientHeight
  var context = canvas.getContext('2d')// 获取到canvas画图的环境，演员表演的舞台
  canvas.width = canvasWidth
  canvas.height = canvasHeight
  var sCode = 'A,B,C,E,F,G,H,J,K,L,M,N,P,Q,R,S,T,W,X,Y,Z,1,2,3,4,5,6,7,8,9,0'
  var aCode = sCode.split(',')
  var aLength = aCode.length// 获取到数组的长度
  let codeArr = []
  for (var i = 0; i <= 3; i++) {
    var j = Math.floor(Math.random() * aLength)// 获取到随机的索引值
    var deg = Math.random() * 30 * Math.PI / 180// 产生0~30之间的随机弧度
    var txt = aCode[j]// 得到随机的一个内容
    codeArr[i] = txt.toLowerCase()
    var x = 10 + i * 20// 文字在canvas上的x坐标
    var y = 20 + Math.random() * 8// 文字在canvas上的y坐标
    context.font = 'bold 23px 微软雅黑'

    context.translate(x, y)
    context.rotate(deg)

    context.fillStyle = randomColor()
    context.fillText(txt, 0, 0)

    context.rotate(-deg)
    context.translate(-x, -y)
  }
  for (let i = 0; i <= 5; i++) { // 验证码上显示线条
    context.strokeStyle = randomColor()
    context.beginPath()
    context.moveTo(Math.random() * canvasWidth, Math.random() * canvasHeight)
    context.lineTo(Math.random() * canvasWidth, Math.random() * canvasHeight)
    context.stroke()
  }
  for (let i = 0; i <= 30; i++) { // 验证码上显示小点
    context.strokeStyle = randomColor()
    context.beginPath()
    let x = Math.random() * canvasWidth
    let y = Math.random() * canvasHeight
    context.moveTo(x, y)
    context.lineTo(x + 1, y + 1)
    context.stroke()
  }
  return codeArr.join('')
}

function randomColor() { // 得到随机的颜色值
  var r = Math.floor(Math.random() * 256)
  var g = Math.floor(Math.random() * 256)
  var b = Math.floor(Math.random() * 256)
  return 'rgb(' + r + ',' + g + ',' + b + ')'
}
